import { getAll } from '@/api/role/index';

export default async function getRolesUtilisateur(roles) {
  const allRoles = (await getAll()).data.result.items;
  const userRoles = allRoles.filter((valueRole) => {
    return roles.includes(valueRole.normalizedName);
  });
  return userRoles;
}
